<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
	<div :class="['todo-tree', { 'tree-have-child': totalChilds > 0, 'todo-tree-hide-multi-level': !multiLevel }]">
		<div class="vs-con-loading__container">
			<vx-card :ref="`parentTodo${todo.id}`" :collapseAction="true" @toggleCollapse="handleChange">
				<div slot="title">
					<div :class="['flex flex-row items-center w-full px-3 todo-parent-title cursor-pointer']" @click="handleClickTodoItemRow($event, todo)">
						<p class="w-6"></p>
						<p class="w-4/5 pl-4 leading-normal font-semibold">{{ todo.name }}</p>
						<p :class="['font-bold todo-item-status font-medium w-1/5 ']">
							<span v-if="todo.type === $constant.TODO_TYPE.NORMAL" :class="[renderStatusColor(todo.status_object.key)]">
								{{ todo.status_object.value }}
							</span>
							<span v-else :class="['font-bold', childProperties(todo.properties).schedule_enable ? 'text-primary' : 'text-danger']">
								{{ childProperties(todo.properties).schedule_enable ? $t("Repeater.TurnedOn") : $t("Repeater.TurnedOff") }}
							</span>
						</p>
						<div class="w-2/5">
							<span v-if="todo.employees">
								<span v-for="employee in todo.employees.slice(0, 3)" :key="employee.id">
									<vx-tooltip class="inline-block" :text="employee.name" position="top">
										<vs-avatar :src="employee.avatar" />
									</vx-tooltip>
								</span>
								<vs-avatar v-if="todo.employees.length > 3" :text="`+${todo.employees.length - 3}`" />
							</span>
						</div>
						<p :class="['todo-item-deadline font-medium w-1/5', { 'text-over-time': todo.is_over_due }]">{{ childProperties(todo.properties).deadline | dateTime(userDateTimeFormat) }}</p>
						<TodoItemContextMenu
							type="vertical"
							:todoItem="todo"
							@onClickEdit="data => callEmitEvent('onClickEdit', data)"
							@onClickRecreate="data => callEmitEvent('onClickRecreate', data)"
							@onClickReminder="data => callEmitEvent('onClickReminder', data)"
							@onClickCancel="data => callEmitEvent('onClickCancel', data)"
							@onClickReject="data => callEmitEvent('onClickReject', data)"
							@onClickCreateRequest="data => callEmitEvent('onClickCreateRequest', data)"
							@onClickToggleScheduleTodo="data => callEmitEvent('onClickToggleScheduleTodo', data)"
							@onClickAddDetail="data => callEmitEvent('onClickAddDetail', data)"
							@viewDetail="data => callEmitEvent('viewDetail', data)"
							@onClickWatcher="data => callEmitEvent('onClickWatcher', data)"
							@onSetStatusTodo="(...data) => callEmitEvent('onSetStatusTodo', ...data)"
							@onCompleteTodo="(...data) => callEmitEvent('onCompleteTodo', ...data)"
							@onClickCreateClone="data => callEmitEvent('onClickCreateClone', data)"
						/>
					</div>
				</div>
				<div v-if="todoListChilds.length > 0 && multiLevel">
					<TodoTree
						v-for="child in todoListChilds"
						:key="`parentChild-Child${child.id}`"
						:todo="child"
						@onClickEdit="data => callEmitEvent('onClickEdit', data)"
						@onClickRecreate="data => callEmitEvent('onClickRecreate', data)"
						@onClickReminder="data => callEmitEvent('onClickReminder', data)"
						@onClickCancel="data => callEmitEvent('onClickCancel', data)"
						@onClickReject="data => callEmitEvent('onClickReject', data)"
						@onClickCreateRequest="data => callEmitEvent('onClickCreateRequest', data)"
						@onClickToggleScheduleTodo="data => callEmitEvent('onClickToggleScheduleTodo', data)"
						@onClickAddDetail="data => callEmitEvent('onClickAddDetail', data)"
						@viewDetail="data => callEmitEvent('viewDetail', data)"
						@onSetMarkedColor="(todoId, color) => callEmitEvent('onSetMarkedColor', todoId, color)"
						@onSetStatusTodo="(...data) => callEmitEvent('onSetStatusTodo', ...data)"
						@onCompleteTodo="(...data) => callEmitEvent('onCompleteTodo', ...data)"
						@onClickWatcher="data => callEmitEvent('onClickWatcher', data)"
					/>
					<el-pagination :hide-on-single-page="true" class="text-right" layout="prev, pager, next" :page-size="limit" :total="totalChilds" @current-change="handlePageChange">
					</el-pagination>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import CbsColorPicker from "@/components/cbs-color-picker/CbsColorPicker";
import TodoItemContextMenu from "./TodoItemContextMenu";
import TodoTree from "./TodoTree";

import { mapGetters } from "vuex";
import { Pagination } from "element-ui";

export default {
	name: "TodoTree",
	components: {
		CbsColorPicker,
		TodoItemContextMenu,
		"el-pagination": Pagination,
		TodoTree
	},
	props: {
		todo: {
			type: Object
		},
		multiLevel: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			page: 1,
			limit: 10,
			totalChilds: 0
		};
	},
	computed: {
		noteColors() {
			return this.$constant.PICKER_MARK_COLORS || [];
		},
		...mapGetters({
			getTodoChildByParent: "todoListManagement/getTodoChildByParent"
		}),
		todoListChilds() {
			return this.getTodoChildByParent(this.todo) || [];
		}
	},
	methods: {
		async handleChange(param) {
			if (!param) {
				this.$refs[`parentTodo${this.todo.id}`].refreshcard();
				await this.getChilds();
				this.$refs[`parentTodo${this.todo.id}`].removeRefreshAnimation();
			}
		},
		async getChilds() {
			const queryOptions = {
				limit: this.limit,
				page: this.page,
				type: this.$constant.TODO_TYPE.NORMAL,
				parent_id: this.todo.id
			};

			const respone = await this.$store.dispatch("todoListManagement/getTodoChildByParent", queryOptions);
			this.totalChilds = respone.totalTodoList;
		},
		handleAddDetailToParent(data) {
			this.$emit("onClickAddDetail", data);
		},
		childProperties(properties) {
			return JSON.parse(properties);
		},

		handleClickTodoItemRow(event, todoItem) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find(className => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				this.$emit("viewDetail", todoItem);
			}
		},
		callEmitEvent(event, ...data) {
			this.$emit(event, ...data);
		},
		handleSetMarkedColor(todoId, color) {
			this.$emit("onSetMarkedColor", todoId, color);
		},
		async handlePageChange(currentPage) {
			this.$store.dispatch("todoListManagement/removeOldChildItems", this.todoListChilds);
			this.page = currentPage;
			this.$refs[`parentTodo${this.todo.id}`].refreshcard();
			await this.getChilds();
			this.$refs[`parentTodo${this.todo.id}`].removeRefreshAnimation();
		},
		async reFetchChilds(parentId) {
			if (!this.$refs[`parentTodo${parentId}`].isContentCollapsed) {
				this.page = 1;
				this.$refs[`parentTodo${parentId}`].refreshcard();
				await this.getChilds();
				this.$refs[`parentTodo${parentId}`].removeRefreshAnimation();
				if (this.$refs[`parentTodo${parentId}`].reFetchChilds()) {
					this.$refs[`parentTodo${parentId}`].reFetchChilds(parentId);
				}
			}
		}
	},
	mounted() {
		this.$refs[`parentTodo${this.todo.id}`].toggleContent();
	}
};
</script>

<style lang="scss">
.todo-tree {
	.vx-card {
		> .vx-card__header {
			// padding: 0 0 0 0.8rem !important;
			background-color: var(--color-white) !important;
		}
	}
	.vx-card__body {
		padding: 0 0 0 0.9rem !important;
		.el-pagination {
			padding-right: 0.9rem !important;
		}
	}
	&.todo-tree-hide-multi-level {
		> .vs-con-loading__container {
			> .vx-card {
				.vx-card__actions {
					display: none;
				}
			}
		}
	}
}
</style>
